import { render, staticRenderFns } from "./ModalSolicitacoesResponder.vue?vue&type=template&id=0db0f1a6&"
import script from "./ModalSolicitacoesResponder.vue?vue&type=script&lang=js&"
export * from "./ModalSolicitacoesResponder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports